import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import DateInput from '../../../DateInput';
import moment from 'moment';
import { dialogStyles } from '../../../../styles/dialogStyles';
import DialogActions from '../../../DialogActions';

interface InactivationDialogProps {
  open: boolean;
  onClose: () => void;
  dates: {
    inactivateStartDate?: Date;
    inactivateEndDate?: Date;
    inactivationStartDate?: Date;
    inactivationEndDate?: Date;
    appointmentEndDate?: Date;
  };
  onStartDateChange: (date: Date) => void;
  onEndDateChange: (date: Date) => void;
  onConfirm: () => void;
  loading?: boolean;
  disabled?: boolean;
  t: (key: string) => string;
  validateInactivationDate: (date: Date) => boolean;
  isActiveAppointment?: boolean;
  endDateError?: string;
}

const InactivationDialog: React.FC<InactivationDialogProps> = ({ 
  open, 
  onClose, 
  dates, 
  onStartDateChange, 
  onEndDateChange, 
  onConfirm, 
  loading,
  disabled,
  t,
  validateInactivationDate: validateDate,
  isActiveAppointment,
  endDateError
}) => {
  if (!open) return null;

  const startDate = dates.inactivateStartDate ?? dates.inactivationStartDate;
  const endDate = dates.inactivateEndDate ?? dates.inactivationEndDate;

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      fullWidth={true} 
      maxWidth="sm"
      PaperProps={{ style: dialogStyles.paper }}
    >
      <DialogTitle style={{ ...dialogStyles.title, textAlign: 'center' as const }}>
        {t('appointment.popup.inactive')}
      </DialogTitle>
      <DialogContent style={dialogStyles.content}>
        <DateInput
          shouldDisableDate={validateDate}
          text={t('appointment.startDate.inactivaction')}
          id="inactivation__startDate"
          value={startDate}
          onChangeValue={onStartDateChange}
          minDate
          maxDateValue={dates.appointmentEndDate}
          required
          disablePast
        />
        <DateInput
          text={t('appointment.endDate.inactivaction')}
          value={endDate}
          onChangeValue={onEndDateChange}
          minDateValue={startDate ?? moment().toDate()}
          maxDateValue={dates.appointmentEndDate}
          disabled={!startDate}
          required={!isActiveAppointment}
          disablePast
          shouldDisableDate={(date: Date) => 
            validateDate(date)
          }
        />
        {endDateError && (
          <p style={dialogStyles.errorMessage}>{endDateError}</p>
        )}
      </DialogContent>
      <DialogActions
        onClose={onClose}
        onConfirm={onConfirm}
        loading={loading}
        disabled={disabled}
        t={t}
      />
    </Dialog>
  );
};

export default InactivationDialog; 